"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = withFlex;
exports.flexPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _breakpointObserver = require("@decisiv/breakpoint-observer");

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var simplePropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.objectOf(_propTypes.default.string)]);

var shorthandPropType = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.objectOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]))]);

var flexPropTypes = {
  alignContent: simplePropType,
  alignItems: simplePropType,
  alignSelf: simplePropType,
  flex: shorthandPropType,
  flexBasis: simplePropType,
  flexDirection: simplePropType,
  flexGrow: shorthandPropType,
  flexShrink: shorthandPropType,
  flexWrap: simplePropType,
  justifyContent: simplePropType,
  justifyItems: simplePropType,
  justifySelf: simplePropType,
  order: shorthandPropType,
  size: _propTypes.default.oneOf(Object.keys(_breakpointObserver.sizes))
};
exports.flexPropTypes = flexPropTypes;

function withFlex() {
  return (0, _styledComponents.css)(["display:flex;", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", " ", ""], (0, _utils.applyDynamicModifiers)('alignContent', 'align-content'), (0, _utils.applyDynamicModifiers)('alignItems', 'align-items'), (0, _utils.applyDynamicModifiers)('alignSelf', 'align-self'), (0, _utils.applyDynamicModifiers)('flex'), (0, _utils.applyDynamicModifiers)('flexBasis', 'flex-basis'), (0, _utils.applyDynamicModifiers)('flexDirection', 'flex-direction'), (0, _utils.applyDynamicModifiers)('flexGrow', 'flex-grow'), (0, _utils.applyDynamicModifiers)('flexShrink', 'flex-shrink'), (0, _utils.applyDynamicModifiers)('flexWrap', 'flex-wrap'), (0, _utils.applyDynamicModifiers)('justifyContent', 'justify-content'), (0, _utils.applyDynamicModifiers)('justifyItems', 'justify-items'), (0, _utils.applyDynamicModifiers)('justifySelf', 'justify-self'), (0, _utils.applyDynamicModifiers)('order'));
}